import configuration, { getConf } from "../../configuration";

export const constructModalId = (prefix: string, fragments: string[]) => {
  if (prefix === "") {
    return fragments.join("-");
  }
  return [prefix, ...fragments].join("-");
};

export const getModalIds = () => {
  return getConf("modalIds", configuration);
};

export const containsDueDateModalQueryParam = (queryParam: string) => {
  const { dueDateModal } = getModalIds();
  // regex for finding duedatemodal concatenated with date string from modal query param
  const regex = new RegExp(`${dueDateModal}\\d{4}-\\d{2}-\\d{2}`, "g");

  const dateFound = queryParam.match(regex);
  if (!dateFound) {
    return null;
  }

  return dateFound[0];
};

export const dateFromDueDateModalQueryParam = (queryParam: string) => {
  // regex for finding duedatemodal concatenated with date string from modal query param
  const regex = /\d{4}-\d{2}-\d{2}/g;

  const dateFound = queryParam.match(regex);

  if (!dateFound) {
    return null;
  }
  return dateFound[0];
};

export const getDetailsModalId = (queryParam: string, prefix: string) => {
  // The id is whatever digits follow the prefix, of any length.
  const regexIdentifier = new RegExp(`(?<=${prefix})\\d+`, "g");
  const modalId = queryParam.match(regexIdentifier);
  if (modalId) {
    const [returnId] = modalId;
    return returnId;
  }
  return "";
};
